import { SonarBranding } from './sonar-print/Sonar';
import type { IBranding } from './_Types/Branding.types';

/**
 * The registry holds only the **active** branding. SonarPrint ships a single branding,
 * so it imports it directly — a plain `vite build` bundles that one branding and no
 * build-time registry swap is needed for isolation.
 *
 * `__BRANDING__` is the compile-time branding define injected by the platform config;
 * it keys the registry so it matches `initialBranding={VITE_BRANDING}`.
 */
/**
 * Resolves the active branding identifier, mapping the `default` sentinel (and any
 * empty/unset value) to `sonar-print`. Shared so the registry key and the BFF
 * `X-Bu-Name` header (see `BFF/config.ts`) always agree on the same identifier.
 */
export const resolveActiveBranding = (): string =>
  typeof __BRANDING__ === 'string' && __BRANDING__ && __BRANDING__ !== 'default'
    ? __BRANDING__
    : 'sonar-print';

const activeBranding = resolveActiveBranding();

const BrandingRegistry: Record<string, IBranding> = {
  [activeBranding]: SonarBranding,
};

export { BrandingRegistry };
export { SonarBranding as DefaultBranding };
